var tw = tw || {};
tw.MemoryGame = (function () {
	var matches = 0,
		//time = 0,
		turns = 0,
		opened = [],
		delay = 900,
		holdData = null,
		chosenTheme = null,
		minutes = 0,
		seconds = 0,
		Interval = null,
		appendMins = null,
		appendSeconds = null;

	//TEMPLATES
	var memoryTemplate = $('#themeTemplate').html();

	/**
	 * Initialize page
	 */
	var initializePage = function () {
		var jqxhr = $.getJSON('/JS/tw/quiz/memory-game/json/data.json', function (data) { // Get json onLoad

			holdData = data; //store this data to shuffle and reload later

			$('.js-select-theme').removeClass('hidden');
			$('.js-load-spinner').addClass('hidden');

			// Load Theme
			$('.js-selected-theme').on('click', function () {
				$('.js-memory-intro').addClass('hidden');
				chosenTheme = $(this).data('theme');
	
				loadTheme(chosenTheme, holdData.matches);
			});
		})
		.fail(function (err) {
			console.error("error:", err);
		});

		// Flip Card
		$(document).on('click', '.js-memory-card:not(".match, .open")', function() {
			if($('.show').length > 1) { return true; }
			
			var $memoryGame = $('.js-memory-game'),
				$this = $(this),
				card = $this.data('card');

			$this.addClass('open show');
			opened.push(card); // Push first card into opened array

				// Compare with opened card
			if (opened.length > 1) {
				console.log(opened[0]);

				if (card === opened[0]) { // Compare newly opened card against previously opened
					$memoryGame.find('.open').addClass('match animated infinite rubberBand');
					
					setTimeout(function() {
						$memoryGame.find('.match').removeClass('open show animated infinite rubberBand');
					}, delay / 1.1);

					matches++;
					$('.js-matches-count').html(matches);

				} else {
					setTimeout(function() {
						$memoryGame.find('.open').addClass('notmatch animated infinite wobble');

						setTimeout(function() {
							$memoryGame.find('.open').removeClass('open notmatch show animated infinite wobble');
						}, delay / 1.6);
					}, delay / 2);
				}

				opened = [];
				turns++;
				$('.js-turns-count').html(turns);
			}
			
			// End Game if match all cards
			if (matches === 10) {
				//var score = setRating(moves).score;
				setTimeout(function() {
					clearInterval(Interval);
					endGame(turns, minutes, seconds);
					matches = 0;
					turns = 0;
					minutes = 0;
					seconds = 0;
				}, 500);
			}
		});

		$(document).on('click', '.js-play-again', function(){
			loadTheme(chosenTheme, holdData.matches);

			$('.js-memory-modal').removeClass('show');
		});

		$(document).on('click', '.js-change-theme', function(){
			chosenTheme = '';
			matches = 0;
			turns = 0;
			clearInterval(Interval);
			minutes = 0;
			seconds = 0;
			$('.js-memory-load-theme').html('');
			$('.js-memory-load-theme').addClass('hidden');
			$('.js-memory-modal').removeClass('show');
			$('.js-memory-intro').removeClass('hidden');
		});

		$(document).on('click', '.js-learn', function(){
			window.open('/article/trip-ideas/match-it-wisconsin-locations');
		});

	};

	/**
	 * Process content from JSON file, Shuffle, trim array
	 * @param {*} data 
	 */
	var loadTheme = function (theme, data) {
		var loadTheme = $('.js-memory-load-theme');
		var tempArr = [];
		var compiledTemplate = Template7.compile(memoryTemplate);
		var tempTheme = theme.replace(/-/g, '_');

		console.log(tempTheme);

		data[tempTheme].forEach(function(match){
			var name = match.match.replace('.jpg', '');

			tempArr.push({
				"name": name,
				"image": theme + "/" + match.match,
				"altText": name.replace(/-/g, ' ')
			});
		});

		var doubleArr = tempArr.concat(tempArr); // double array to create matches
		var shuffledArr = shuffle(doubleArr); //randomize matches

		var themeContent = {
			matches: shuffledArr
		};

		var html = compiledTemplate(themeContent);

		loadTheme.html('');
		loadTheme.append(html);
		if(loadTheme.hasClass('hidden')) loadTheme.removeClass('hidden');

		appendMins = $('.js-time-minutes');
		appendSeconds = $('.js-time-seconds');
		clearInterval(Interval);
		Interval = setInterval(startTimer, 1000);
	};

	var endGame = function (turns, minutes, seconds) {
		var memoryModal = $('.js-memory-modal');

		if(seconds <= 9){ seconds = "0" + seconds; }

		$('.js-results-minutes').html(minutes);
		$('.js-results-seconds').html(seconds);
		$('.js-results-turns').html(turns);

		memoryModal.addClass('show');
	};

	// Shuffle function From http://stackoverflow.com/a/2450976
	var shuffle = function(array) {
		var currentIndex = array.length, temporaryValue, randomIndex;
		
		while (0 !== currentIndex) {
			randomIndex = Math.floor(Math.random() * currentIndex);
			currentIndex -= 1;
			temporaryValue = array[currentIndex];
			array[currentIndex] = array[randomIndex];
			array[randomIndex] = temporaryValue;
		}
	
		return array;
	};

	var startTimer = function() {
		seconds++; 
			
		if(seconds <= 9){ appendSeconds.html("0" + seconds); }
		
		if (seconds > 9){ appendSeconds.html(seconds); } 
		
		if (seconds >= 60) {
			minutes++;
			appendMins.html("0" + minutes);

			seconds = 0;
			appendSeconds.html("00");
		}
		
		if (minutes > 9){ appendMins.html(minutes); }
	};

	$(initializePage); //doc ready
}());